exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sau-select[data-v-5e19fe8b] {\n  border: none;\n  -moz-text-align-last: center;\n  text-align-last: center;\n  text-align: center;\n  padding-top: 0px !important;\n}\n.sau-select[data-v-5e19fe8b]:focus, .sau-select[data-v-5e19fe8b]:hover {\n  outline: none;\n  box-shadow: none;\n  border: none;\n}\n.sau-select[data-v-5e19fe8b] {\n  padding-top: 0px !important;\n}\n.icon-large[data-v-5e19fe8b] {\n  font-size: 3rem;\n}\n.sau-bx-right[data-v-5e19fe8b] {\n  border-top: 0;\n  border-left: 0;\n  border-bottom: 0;\n}", ""]);

// exports
